import { DatePicker, Select } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { FormikProps, useFormik } from 'formik';
import { useState } from 'react';
import { workShiftCalendar } from 'utils';
type WorkShiftCalendarProps = {
  addCalendar: boolean;
  onClose: () => void;
  data?: any;
  workShiftList?: any;
  onDataChanged?: (data) => void;
  finalData?: any;
  role?: string;
  parentFormik?: FormikProps<any>;
};

const WorkShiftCalendar = ({
  addCalendar,
  onClose,
  workShiftList,
  role,
  parentFormik,
}: WorkShiftCalendarProps) => {
  const [state, setState] = useState({
    tableData: [],
  });

  const { tableData } = state;
  const formik = useFormik({
    initialValues: {
      workshift_policy_id: null,
      // start_date: '',
      // end_date: '',
      // cyclic_start_date: '',
    },
    onSubmit: (data: workShiftCalendar) => {
      onClose();
      addToTable(data);
      parentFormik.setFieldValue('workshifts', [
        ...parentFormik?.values.workshifts,
        data,
      ]);
    },
  });

  const addToTable = (data: workShiftCalendar) => {
    setState((pre) => ({
      ...pre,
      tableData: [...tableData, data],
    }));
  };

  const handleChangeOption = (value, current) => {
    parentFormik.setFieldValue('workshifts', [
      { ...current, workshift_policy_id: value },
    ]);
  };

  return (
    <div>
      {Array.isArray(parentFormik?.values.workshifts) && (
        <div>
          {parentFormik?.values.workshifts?.length === 0 && !addCalendar ? (
            <div
              style={{ marginLeft: '45%', marginTop: '10px', color: '#D1D1D1' }}
            >
              No item
            </div>
          ) : (
            parentFormik?.values.workshifts?.map(
              (
                item: {
                  workshift_policy_id: string | number | readonly string[];
                  start_date: string | number | dayjs.Dayjs | Date;
                  end_date: string | number | dayjs.Dayjs | Date;
                  cyclic_start_date: string | number | dayjs.Dayjs | Date;
                },
                index: number,
              ) => (
                <div key={index}>
                  <div
                    style={{
                      display: 'flex',
                      width: '100%',
                      gap: 10,
                      marginTop: 15,
                      paddingLeft: 20,
                    }}
                  >
                    <div style={{ width: '23%' }}>
                      <Select
                        options={workShiftList}
                        onChange={(e) => {
                          handleChangeOption(e, item);
                        }}
                        value={item.workshift_policy_id}
                        disabled={role !== 'admin'}
                        defaultValue={null}
                        style={{
                          borderRadius: 0,
                          border: '0.5px solid #407fdd',
                          width: '100%',
                          outline: 'none',
                          height: 32,
                        }}
                        className="children_dependents_select"
                      />
                    </div>
                    <div
                      style={{ width: '22%' }}
                      className="edit_item_date_new"
                    >
                      <DatePicker
                        suffixIcon={
                          <img src="/icons/calendar.svg" alt="icon" />
                        }
                        allowClear={false}
                        disabled={role !== 'admin'}
                        value={
                          item?.start_date ? dayjs(item?.start_date) : undefined
                        }
                        // id="start_date"
                        onChange={(value) => {
                          parentFormik.setFieldValue('workshifts', [
                            {
                              ...item,
                              start_date: value
                                ? dayjs(value).format('YYYY-MM-DD')
                                : dayjs().format('YYYY-MM-DD'),
                            },
                          ]);
                        }}
                        inputReadOnly
                        disabledDate={(current) => {
                          const endDate = item.end_date;

                          const isAfterEndDate = current.isAfter(
                            dayjs(endDate),
                          );

                          // Disable if the date is before start date or after end date
                          return isAfterEndDate;
                        }}
                        className="add_user_date_picker"
                        placeholder=""
                        style={{
                          width: '100%',
                          border: '0.5px solid #407fdd',
                          borderRadius: '2px',
                        }}
                      />
                    </div>
                    <div
                      style={{ width: '23%' }}
                      className="edit_item_date_new"
                    >
                      <DatePicker
                        disabled={role !== 'admin'}
                        suffixIcon={
                          <img src="/icons/calendar.svg" alt="icon" />
                        }
                        inputReadOnly
                        disabledDate={(current) => {
                          const startDate = item.start_date;

                          const isAfterEndDate = current.isBefore(
                            dayjs(startDate),
                          );

                          // Disable if the date is before start date or after end date
                          return isAfterEndDate;
                        }}
                        value={item?.end_date ? dayjs(item?.end_date) : null}
                        // id="end_date"
                        onChange={(value) => {
                          parentFormik.setFieldValue('workshifts', [
                            {
                              ...item,
                              end_date: value
                                ? dayjs(value).format('YYYY-MM-DD')
                                : value,
                            },
                          ]);
                        }}
                        className="add_user_date_picker"
                        placeholder=""
                        style={{
                          width: '100%',
                          border: '0.5px solid #407fdd',
                          borderRadius: '2px',
                        }}
                      />
                    </div>
                    <div
                      style={{ width: '25%' }}
                      className="edit_item_date_new"
                    >
                      <DatePicker
                        suffixIcon={
                          <img src="/icons/calendar.svg" alt="icon" />
                        }
                        disabled={role !== 'admin'}
                        value={
                          item?.cyclic_start_date
                            ? dayjs(item?.cyclic_start_date)
                            : null
                        }
                        inputReadOnly
                        id="cyclic_start_date"
                        onChange={(value) => {
                          parentFormik.setFieldValue('workshifts', [
                            {
                              ...item,
                              cyclic_start_date: value
                                ? dayjs(value).format('YYYY-MM-DD')
                                : value,
                            },
                          ]);
                        }}
                        disabledDate={(current) => {
                          const startDate = item.start_date;
                          const endDate = item.end_date;
                          const isBeforeStartDate = current.isBefore(
                            dayjs(startDate),
                          );
                          const isAfterEndDate = current.isAfter(
                            dayjs(endDate),
                          );

                          // Disable if the date is before start date or after end date
                          return (
                            (startDate && isBeforeStartDate) ||
                            (endDate && isAfterEndDate)
                          );
                        }}
                        className="add_user_date_picker"
                        placeholder=""
                        style={{
                          width: '100%',
                          border: '0.5px solid #407fdd',
                          borderRadius: '2px',
                        }}
                      />
                    </div>
                  </div>
                </div>
              ),
            )
          )}
          {addCalendar && parentFormik?.values?.workshifts?.length < 1 && (
            <div>
              <form
                onSubmit={formik.handleSubmit}
                style={{
                  display: 'flex',
                  width: '100%',
                  gap: 10,
                  marginTop: 15,
                  paddingLeft: 20,
                }}
              >
                <div style={{ width: '23%' }}>
                  <Select
                    options={workShiftList}
                    onChange={(value) =>
                      formik.setFieldValue('workshift_policy_id', value)
                    }
                    disabled={role !== 'admin'}
                    defaultValue={null}
                    value={formik.values.workshift_policy_id}
                    style={{
                      borderRadius: 0,
                      border: '0.5px solid #407fdd',
                      width: '100%',
                      outline: 'none',
                      height: 32,
                    }}
                    className="children_dependents_select"
                  />
                </div>
                <div style={{ width: '22%' }} className="edit_item_date_new">
                  <DatePicker
                    suffixIcon={<img src="/icons/calendar.svg" alt="icon" />}
                    // id="start_date"
                    allowClear={false}
                    onChange={(e) =>
                      formik.setFieldValue(
                        'start_date',
                        (e as Dayjs).format('YYYY-MM-DD'),
                      )
                    }
                    disabledDate={(current) => {
                      return (
                        current &&
                        current > dayjs(formik.values.end_date, 'YYYY-MM-DD')
                      );
                    }}
                    className="add_user_date_picker"
                    placeholder=""
                    style={{
                      width: '100%',
                      border: '0.5px solid #407fdd',
                      borderRadius: '2px',
                    }}
                  />
                </div>
                <div style={{ width: '23%' }} className="edit_item_date_new">
                  <DatePicker
                    suffixIcon={<img src="/icons/calendar.svg" alt="icon" />}
                    onChange={(e) =>
                      formik.setFieldValue(
                        'end_date',
                        (e as Dayjs).format('YYYY-MM-DD'),
                      )
                    }
                    disabledDate={(current) => {
                      return (
                        current &&
                        current < dayjs(formik.values.start_date, 'YYYY-MM-DD')
                      );
                    }}
                    className="add_user_date_picker"
                    placeholder=""
                    style={{
                      width: '100%',
                      border: '0.5px solid #407fdd',
                      borderRadius: '2px',
                    }}
                  />
                </div>
                <div style={{ width: '25%' }} className="edit_item_date_new">
                  <DatePicker
                    suffixIcon={<img src="/icons/calendar.svg" alt="icon" />}
                    onChange={(e) =>
                      formik.setFieldValue(
                        'cyclic_start_date',
                        (e as Dayjs).format('YYYY-MM-DD'),
                      )
                    }
                    disabledDate={(current) => {
                      return (
                        current &&
                        (current >
                          dayjs(formik.values.end_date, 'YYYY-MM-DD') ||
                          current <
                            dayjs(formik.values.start_date, 'YYYY-MM-DD'))
                      );
                    }}
                    className="add_user_date_picker"
                    placeholder=""
                    style={{
                      width: '100%',
                      border: '0.5px solid #407fdd',
                      borderRadius: '2px',
                    }}
                  />
                </div>

                <div
                  style={{ display: 'flex', padding: 5, gap: 10, width: '5%' }}
                >
                  <div
                    style={{ padding: 0, border: 'none', background: 'white' }}
                    onClick={() => formik.handleSubmit()}
                  >
                    <img
                      style={{ cursor: 'pointer' }}
                      src="/icons/accept.svg"
                      alt="accept"
                    />
                  </div>
                  <img
                    onClick={() => onClose()}
                    style={{ cursor: 'pointer' }}
                    src="/icons/decline.svg"
                    alt="decline"
                  />
                </div>
              </form>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default WorkShiftCalendar;
